<template>
  <div
    @click.self="closeModal"
    v-if="itemData"
    class="modalContainer"
    role="dialog"
    tabindex="-1"
    ref="modal"
    aria-modal="true"
    aria-hidden="false"
  >
    <NestedModifierModal
      v-if="upsellModalIsVisible"
      @goBack="goBack"
      @doneButtonClicked="getSubChoices"
      :upsellData="selectedUpsellData"
      :itemQuantity="itemQuantity"
      :mode="nestedModalMode"
      :choiceChildItems="choiceChildItems"
      :parentChoiceQty="parentChoiceQty"
    />
    <ItemAllergenModal
      class="itemAllergenModal"
      v-if="ItemAllergenModalIsOpen"
      @closeModal="toggleItemAllergenModal"
      @addToCart="handleAddToCart"
    />
    <div v-show="itemModalIsVisible" class="modalWrapper">
      <div @click="closeModal" class="close" tabindex="1" aria-label="Close modal" role="button">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.1161 6.6228L7.75908 6.97635L8.11437 7.33163L13.4572 12.6745L12.6745 13.4572L11.8466 12.6294L11.8449 12.6277L7.37718 8.11608L7.02364 7.75906L6.66835 8.11435L1.32551 13.4572L0.542786 12.6745L5.88563 7.33163L6.24062 6.97664L5.8842 6.62309L0.543158 1.32514L1.32551 0.542787L6.66835 5.88563L7.02334 6.24061L7.37689 5.88419L12.6748 0.543155L13.4572 1.32551L12.6294 2.15333L12.6277 2.15504L8.1161 6.6228ZM12.7648 13.5475C12.7649 13.5476 12.765 13.5478 12.7651 13.5479L12.7648 13.5475ZM0.452113 12.7651L0.452145 12.7651C0.452134 12.7651 0.452123 12.7651 0.452113 12.7651Z"
            fill="black"
            stroke="black"
          />
        </svg>
      </div>
      <div
        class="itemNameBar"
        :class="{ show: showItemNameBar }"
        :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
      >
        <p>{{ itemData.item_name }}</p>
      </div>
      <a
        v-if="loggedIn"
        @click="favoriteClicked"
        class="favorite"
        :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
      >
        <svg
          v-if="!favorited"
          class="favoriteEmpty"
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="28.043"
          viewBox="0 0 32 28.043"
        >
          <path
            id="heart"
            d="M46.654,0A7.425,7.425,0,0,0,39.83,4.53,7.422,7.422,0,0,0,33.006,0C27.9,0,24.83,4.864,
                24.83,8.874c0,6.719,15,16.959,15,16.959s15-10.238,15-16.958C54.83,4.864,51.758,0,46.654,0Z"
            transform="translate(-23.83 1)"
            fill="none"
            stroke="#000"
            stroke-width="3"
          />
        </svg>
        <svg
          v-if="favorited"
          class="favoriteFill"
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="25.832"
          viewBox="0 0 30 25.832"
        >
          <path
            id="heart-fill"
            d="M46.654,0A7.425,7.425,0,0,0,39.83,4.53,7.422,7.422,0,0,0,33.006,0C27.9,0,24.83,
          4.864,24.83,8.874c0,6.719,15,16.959,15,16.959s15-10.238,15-16.958C54.83,4.864,51.758,0,46.654,0Z"
            transform="translate(-24.83)"
            fill="#010101"
          />
        </svg>
      </a>
      <div @scroll="getScrolledPosition" class="itemModalWrapper">
        <div v-if="checkIfImageIsVisible" class="itemImageWrapper">
          <img
            class="itemImage"
            :src="itemData.image_urls.standard"
            :alt="itemData.item_name"
            loading="lazy"
            tabindex="2"
          />
        </div>
        <div class="itemInfoWrapper">
          <div class="itemInfo">
            <div class="infoWrapper" :style="{ marginTop: checkIfImageIsVisible ? '0px' : '40px' }">
              <h3 class="itemName" tabindex="3">{{ itemData.item_name }}</h3>
              <div class="priceWrapper">
                <h3 class="itemPrice" tabindex="4">{{ formatPrice(finalPrice) }}</h3>
                <p
                  v-if="
                    normalizedAddons.calories &&
                    normalizedAddons.calories[selectedSizeIndex != null ? selectedSizeIndex : 0].min_calorie != null
                  "
                  class="itemCalorie"
                  tabindex="5"
                >
                  <span
                    v-if="
                      normalizedAddons.calories[selectedSizeIndex != null ? selectedSizeIndex : 0].min_calorie ==
                      normalizedAddons.calories[selectedSizeIndex != null ? selectedSizeIndex : 0].max_calorie
                    "
                  >
                    •
                    {{
                      normalizedAddons.calories[selectedSizeIndex != null ? selectedSizeIndex : 0].min_calorie *
                      itemQuantity
                    }}
                    cals
                  </span>
                  <span v-else>
                    •
                    {{
                      normalizedAddons.calories[selectedSizeIndex != null ? selectedSizeIndex : 0].min_calorie *
                      itemQuantity
                    }}
                    cals -
                    {{
                      normalizedAddons.calories[selectedSizeIndex != null ? selectedSizeIndex : 0].max_calorie *
                      itemQuantity
                    }}
                    cals
                  </span>
                </p>
              </div>
              <p class="itemDescription" tabindex="5" v-if="itemData.long_description != ''">
                {{ itemData.long_description }}
              </p>
              <div v-if="itemData.allergen_ids || itemData.class_ids" class="allergyIcons" tabIndex=6>
                <div v-for="(allergen, index) in getUniqueAllergyIcons()" :key="index" class="allergens">
                  <p class="allergensNoIcon" v-if="!allergen.icon_url"  aria-hidden="true">{{ allergen.display }}</p>
                  <img
                    v-if="allergen.icon_url"
                    :src="allergen.icon_url"
                    :alt="allergen.name"
                    class="allergen-icon"
                    tabindex="7"
                  />
                  <br />
                  <div class="tooltip" aria-hidden="true">
                    {{ allergen.name }}
                  </div>
                </div>
              </div>
              <div v-if="allergenIds || itemClassIds">
                <p
                  v-if="(allergenIds && allergenIds.length > 0) || (itemClassIds && itemClassIds.length > 0)"
                  class="error-message"
                  tabindex="8"
                >
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-label="Filters"
                  >
                    <path
                      d="M6.52539 12.7461C5.70898 12.7461 4.93945 12.5898 4.2168 12.2773C3.49805 11.9648 2.86328 11.5332 2.3125 10.9824C1.76172 10.4316 1.33008 9.79688 1.01758 9.07812C0.705078 8.35547 0.548828 7.58594 0.548828 6.76953C0.548828 5.95312 0.705078 5.18555 1.01758 4.4668C1.33008 3.74414 1.75977 3.10742 2.30664 2.55664C2.85742 2.00586 3.49219 1.57422 4.21094 1.26172C4.93359 0.949219 5.70312 0.792969 6.51953 0.792969C7.33594 0.792969 8.10547 0.949219 8.82812 1.26172C9.55078 1.57422 10.1875 2.00586 10.7383 2.55664C11.2891 3.10742 11.7207 3.74414 12.0332 4.4668C12.3457 5.18555 12.502 5.95312 12.502 6.76953C12.502 7.58594 12.3457 8.35547 12.0332 9.07812C11.7207 9.79688 11.2891 10.4316 10.7383 10.9824C10.1875 11.5332 9.55078 11.9648 8.82812 12.2773C8.10938 12.5898 7.3418 12.7461 6.52539 12.7461ZM6.52539 11.75C7.2168 11.75 7.86328 11.6211 8.46484 11.3633C9.06641 11.1055 9.5957 10.75 10.0527 10.2969C10.5098 9.83984 10.8652 9.31055 11.1191 8.70898C11.377 8.10742 11.5059 7.46094 11.5059 6.76953C11.5059 6.07812 11.377 5.43164 11.1191 4.83008C10.8613 4.22852 10.5039 3.69922 10.0469 3.24219C9.59375 2.78516 9.06445 2.42969 8.45898 2.17578C7.85742 1.91797 7.21094 1.78906 6.51953 1.78906C5.82812 1.78906 5.18164 1.91797 4.58008 2.17578C3.97852 2.42969 3.45117 2.78516 2.99805 3.24219C2.54492 3.69922 2.18945 4.22852 1.93164 4.83008C1.67773 5.43164 1.55078 6.07812 1.55078 6.76953C1.55078 7.46094 1.67773 8.10742 1.93164 8.70898C2.18945 9.31055 2.54492 9.83984 2.99805 10.2969C3.45508 10.75 3.98438 11.1055 4.58594 11.3633C5.1875 11.6211 5.83398 11.75 6.52539 11.75ZM6.51953 7.82422C6.21875 7.82422 6.06445 7.66992 6.05664 7.36133L5.98047 4.26172C5.97656 4.11328 6.02344 3.99023 6.12109 3.89258C6.22266 3.79492 6.35352 3.74609 6.51367 3.74609C6.66992 3.74609 6.79883 3.79688 6.90039 3.89844C7.00586 3.99609 7.05664 4.11914 7.05273 4.26758L6.96484 7.36133C6.96094 7.66992 6.8125 7.82422 6.51953 7.82422ZM6.51953 9.72852C6.34766 9.72852 6.19922 9.66992 6.07422 9.55273C5.94922 9.43164 5.88672 9.28711 5.88672 9.11914C5.88672 8.95117 5.94922 8.80859 6.07422 8.69141C6.19922 8.57031 6.34766 8.50977 6.51953 8.50977C6.69141 8.50977 6.83984 8.56836 6.96484 8.68555C7.08984 8.80273 7.15234 8.94727 7.15234 9.11914C7.15234 9.29102 7.08789 9.43555 6.95898 9.55273C6.83398 9.66992 6.6875 9.72852 6.51953 9.72852Z"
                      fill="#E75743"
                    />
                  </svg>
                  <span class="visually-hidden">Contains:</span>
                  {{
                    (allergenIds || [])
                      .concat(itemClassIds || [])
                      .map((item) =>
                        item.name
                          .split(' ')
                          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                          .join(' ')
                      )
                      .join(', ')
                  }}
                </p>
              </div>
            </div>
            <div v-if="checkNutritionInfoAvailable" class="nutritionButton">
              <a @click="toggleNutritionInfo" href="javascript:;">
                <p>{{ showNutritionInfo ? 'Hide' : 'Show' }} Nutrition Info</p>
              </a>
            </div>
            <div v-if="getNutritionInfo && showNutritionInfo" class="nutrationInfo">
              <div v-if="getNutritionInfo.serving_size" class="line">
                <p class="nutrionLabel">Serving Size</p>
                <p class="nutrionValue">{{ getNutritionInfo.serving_size }}oz</p>
              </div>
              <div v-if="getNutritionInfo.calories" class="line">
                <p class="nutrionLabel">Calories</p>
                <p class="nutrionValue">
                  {{ getNutritionInfo.calories }}
                </p>
              </div>
              <div v-if="getNutritionInfo.fat" class="line">
                <p class="nutrionLabel">Fat</p>
                <p class="nutrionValue">{{ getNutritionInfo.fat }}g</p>
              </div>
              <div v-if="getNutritionInfo.fat_calories" class="line">
                <p class="nutrionLabel">Fat Calories</p>
                <p class="nutrionValue">
                  {{ getNutritionInfo.fat_calories }}
                </p>
              </div>
              <div v-if="getNutritionInfo.trans_fat" class="line">
                <p class="nutrionLabel">Trans Fat</p>
                <p class="nutrionValue">{{ getNutritionInfo.trans_fat }}g</p>
              </div>
              <div v-if="getNutritionInfo.saturated_fat" class="line">
                <p class="nutrionLabel">Saturated Fat</p>
                <p class="nutrionValue">{{ getNutritionInfo.saturated_fat }}g</p>
              </div>
              <div v-if="getNutritionInfo.cholesterol" class="line">
                <p class="nutrionLabel">Cholesterol</p>
                <p class="nutrionValue">{{ getNutritionInfo.cholesterol }}mg</p>
              </div>
              <div v-if="getNutritionInfo.sodium" class="line">
                <p class="nutrionLabel">Sodium</p>
                <p class="nutrionValue">{{ getNutritionInfo.sodium }}mg</p>
              </div>
              <div v-if="getNutritionInfo.carbs" class="line">
                <p class="nutrionLabel">Carbs</p>
                <p class="nutrionValue">{{ getNutritionInfo.carbs }}g</p>
              </div>
              <div v-if="getNutritionInfo.fiber" class="line">
                <p class="nutrionLabel">Fiber</p>
                <p class="nutrionValue">{{ getNutritionInfo.fiber }}g</p>
              </div>
              <div v-if="getNutritionInfo.sugars" class="line">
                <p class="nutrionLabel">Sugars</p>
                <p class="nutrionValue">{{ getNutritionInfo.sugars }}g</p>
              </div>
              <div v-if="getNutritionInfo.protein" class="line">
                <p class="nutrionLabel">Protein</p>
                <p class="nutrionValue">{{ getNutritionInfo.protein }}g</p>
              </div>
            </div>
            <div v-if="normalizedAddons" tabindex="9">
              <div v-if="normalizedAddons.sizes" class="sizeWrapper">
                <div class="sizeHeader">
                  <p class="modifierName">Choose {{ itemData.size_label }}</p>
                  <p v-if="selectSizeMessage" class="validation">Please select a size</p>
                </div>
                <div class="sizes">
                  <div
                    :class="{ activeSize: selectedSizeIndex == index }"
                    @click="selectSize(index)"
                    v-for="(size, index) in normalizedAddons.addOn"
                    :key="size"
                    class="size"
                  >
                    <h4 class="sizeName">{{ size.sizename }}</h4>
                    <div v-if="!normalizedAddons.styles" class="sizeInfo">
                      <p>{{ formatPrice(size.prices.display_price) }}</p>
                      <p
                        v-if="normalizedAddons.calories && normalizedAddons.calories[index].min_calorie != null"
                        class="itemCalorie"
                      >
                        <span
                          v-if="
                            normalizedAddons.calories[index].min_calorie == normalizedAddons.calories[index].max_calorie
                          "
                        >
                          {{ normalizedAddons.calories[index].min_calorie * itemQuantity }}
                          cals
                        </span>
                        <span v-else>
                          {{ normalizedAddons.calories[index].min_calorie * itemQuantity }}
                          cals -
                          {{ normalizedAddons.calories[index].max_calorie * itemQuantity }}
                          cals
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="normalizedAddons.styles && selectedSizeIndex !== null" class="styleWrapper">
                <div class="styleHeader">
                  <p class="modifierName">Choose {{ itemData.style_label }}</p>
                  <p v-if="selectStyleMessage" class="validation">Please select a style</p>
                </div>
                <div class="styles">
                  <div
                    :class="{ activeSize: selectedStyleIndex == index }"
                    @click="selectStyle(index, style.detail.style_id)"
                    v-for="(style, index) in normalizedAddons.addOn[selectedSizeIndex].styleList"
                    :key="style"
                    class="size"
                  >
                    <h4 class="sizeName">{{ style.detail.style_name }}</h4>
                    <div class="sizeInfo">
                      <p>{{ formatPrice(style.priceList.display_price) }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="getModifiers && getModifiers.length > 0" class="modifiers">
                <div v-for="modifier in getModifiers" :key="modifier" class="modifier">
                  <div v-show="modifier.display_style != 'hidden'" class="modifierWrapper">
                    <div
                      class="modifierHeader"
                      @click="expandModifier(modifier.pick_list_id)"
                      :style="branding?.display_options?.collapsable_modifiers ? 'cursor: pointer' : ''"
                    >
                      <div class="modifierInfo">
                        <h3 class="modifierName">{{ modifier.prompt }}</h3>
                        <div class="modifierTypeWrapper">
                          <p class="modifierType">
                            {{ modifier.mincount == 0 ? 'OPTIONAL' : 'REQUIRED' }}
                          </p>
                          <p v-if="getMinMax(modifier) != ''" class="modifierSelect">
                            {{ getMinMax(modifier) }}
                          </p>
                        </div>
                      </div>
                      <svg
                        v-if="branding?.display_options?.collapsable_modifiers"
                        src="@/assets/icons/downArrow.svg"
                        class="expandCollapse"
                        :class="{ rotate: checkIfModifierVisible(modifier.pick_list_id) }"
                        width="12"
                        height="9"
                        viewBox="0 0 12 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.53558 7.93101L0.221517 2.61692C-0.0347764 2.36063 -0.0347764 1.94511 0.221517 1.68885L0.841317 1.06904C1.09717 0.813189 1.51184 0.812697 1.7683 1.06795L5.99963 5.27946L10.2309 1.06795C10.4874 0.812697 10.9021 0.813189 11.1579 1.06904L11.7777 1.68885C12.034 1.94514 12.034 2.36065 11.7777 2.61692L6.46368 7.93101C6.20739 8.18728 5.79188 8.18728 5.53558 7.93101Z"
                          fill="#171717"
                        />
                      </svg>
                    </div>
                    <div
                      v-show="checkIfModifierVisible(modifier.pick_list_id)"
                      :class="{ gridChoices: branding?.display_options?.modifier_display_style == 'grid' }"
                    >
                      <ChoiceCell
                        tabindex="10"
                        v-for="choice in modifier.pick_list_items"
                        :key="choice"
                        :choice="choice"
                        :modifier="modifier"
                        @openUpsellModal="openUpsellModal"
                        @selectSide="selectSide"
                        @changeChoiceQty="changeChoiceQty"
                        :checkIfFallbackImage="checkIfFallbackImage"
                        :selected="checkIfSelected(modifier, choice)"
                        :selectedCount="getSelectedCount(choice.itemid)"
                        :selectedChildItemNames="getSelectedChildItemNames(choice.itemid, modifier.pick_list_id)"
                        :leftSelected="checkIfSideSelected(choice, 'Left')"
                        :rightSelected="checkIfSideSelected(choice, 'Right')"
                        :wholeSelected="checkIfSideSelected(choice, 'Whole')"
                        :pizzaSidePrice="getPizzaSidePrice(choice)"
                        :multiChoiceQuantity="getMultiChoiceQuantity(choice)"
                        :hasRequiredNestedModifiers="checkIfHasRequiredNestedModifiers(modifier, choice)"
                        @click="checkIfShouldScrollToNext(modifier, choice)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!itemData.disable_special_instructions" class="specialInstructions inputWrapper">
              <div class="labelWrapper">
                <label class="orderNoteHeader" for="special">{{
                  branding?.display_options?.item_note_label || 'Add an Item Note'
                }}</label>
                <p class="count">{{ specialInstructions.length }}/120</p>
              </div>
              <textarea
                v-model="specialInstructions"
                id="special"
                cols="30"
                rows="3"
                maxlength="120"
                :placeholder="
                  storeConfig.custom_content &&
                  storeConfig.custom_content.copy_text &&
                  storeConfig.custom_content.copy_text.item_comment_placeholder
                    ? storeConfig.custom_content.copy_text.item_comment_placeholder
                    : ''
                "
              >
              </textarea>
            </div>
          </div>
          <div class="addToCartPart">
            <div class="itemQtyPart">
              <div class="itemQtyWrapper">
                <button
                  @click="changeQty('minus')"
                  :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
                  aria-label="Decrease quantity"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 149 12">
                    <rect id="Rectangle_3708" data-name="Rectangle 3708" width="149" height="12" rx="6" />
                  </svg>
                </button>
                <div
                  class="itemQty"
                  :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
                  aria-live="polite"
                  aria-atomic="true"
                  aria-relevant="text"
                >
                  <p v-if="checkIfMobileDevice">{{ itemQuantity }}</p>
                  <input
                    v-else
                    type="number"
                    v-model="itemQuantity"
                    :disabled="checkIfMobileDevice"
                    @input="itemQuantity = $event.target.value"
                    @keydown="checkQtyConditions"
                    aria-label="Quantity"
                    aria-describedby="quantityError"
                  />
                </div>
                <button
                  @click="changeQty('plus')"
                  :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
                  aria-label="Increase quantity"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 149 149">
                    <path
                      id="plus"
                      d="M68.5,143V80.5H6a6,6,0,1,1,0-12H68.5V6a6,6,0,1,1,12,0V68.5H143a6,6,0,1,1,0,12H80.5V143a6,6,0,1,1-12,0Z"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <button
              @click="addToCart"
              :disabled="buttonLoader"
              class="addToCart"
              :style="{
                backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF',
                color: branding.dark_mode_enabled ? '#FFFFFF' : 'var(--text-color)',
              }"
            >
              <div v-if="buttonLoader" class="loader buttonLoader"></div>
              <template v-if="!buttonLoader">
                {{
                  mode == 'add'
                    ? 'Add To Cart • ' + formatPrice(finalPrice)
                    : 'Update Item • ' + formatPrice(finalPrice)
                }}
              </template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import choiceMixins from '@/mixins/choiceMixins.js'
import formattingMixins from '@/mixins/formattingMixins.js'
import allergensMixins from '@/mixins/allergensMixins'
import menuItemImageVisibility from '@/mixins/menuItemImageVisibility'

import { mapState, mapMutations } from 'vuex'
import NestedModifierModal from './NestedModifierModal.vue'
import ChoiceCell from './ChoiceCell.vue'

import modalMixins from '@/mixins/modalMixins.js'

import customersApi from '@/api/customersApi'
import ordersApi from '@/api/ordersApi'
import ItemAllergenModal from '@/components/Modals/FilterModals/ItemAllergenModal.vue'

export default {
  data() {
    return {
      specialInstructions: '',
      itemQuantity: 1,
      sizePrice: 0,
      selectedSizeIndex: null,
      selectSizeMessage: false,
      itemModalIsVisible: true,
      selectedUpsellData: null,
      upsellModalIsVisible: false,
      showNutritionInfo: false,
      favorited: false,
      favoriteData: null,
      showItemNameBar: false,
      selectedStyleIndex: null,
      selectStyleMessage: false,
      selectedStyleId: null,
      nestedModalMode: 'add',
      choiceChildItems: null,
      parentChoiceQty: null,
      windowWidth: window.innerWidth,
      expandedModifiers: [],
      modifierId: '',
      ItemAllergenModalIsOpen: false,
    }
  },
  mixins: [choiceMixins, modalMixins, formattingMixins, allergensMixins, menuItemImageVisibility],
  components: {
    NestedModifierModal,
    ChoiceCell,
    ItemAllergenModal,
  },
  props: ['itemData', 'normalizedAddons', 'mode', 'editItemData'],
  computed: {
    ...mapState(['buttonLoader', 'storeConfig', 'loggedIn', 'branding', 'cookies', 'selectedStore', 'orderData']),
    finalPrice() {
      return (this.sizePrice + this.choicesPrice) * this.itemQuantity
    },
    checkIfMobileDevice() {
      return this.windowWidth < 768
    },
    checkNutritionInfoAvailable() {
      // get modifiers if there are no sizes
      if (!this.normalizedAddons.sizes && this.normalizedAddons.nutrition) {
        return true
      }
      // get modifiers if there are sizes and no styles
      if (
        this.normalizedAddons.sizes &&
        !this.normalizedAddons.styles &&
        this.selectedSizeIndex != null &&
        this.normalizedAddons.addOn[this.selectedSizeIndex].nutrition
      ) {
        return true
      }
      // get modifiers if there are styles and no sizes
      if (
        !this.normalizedAddons.sizes &&
        this.normalizedAddons.styles &&
        this.selectedStyleIndex != null &&
        this.normalizedAddons.addOn[this.selectedStyleIndex].nutrition
      ) {
        return true
      }
      // get modifiers if there are sizes and styles
      if (
        this.normalizedAddons.sizes &&
        this.normalizedAddons.styles &&
        this.selectedSizeIndex != null &&
        this.selectedStyleIndex != null &&
        this.normalizedAddons.addOn[this.selectedSizeIndex].styleList[this.selectedStyleIndex].nutrition
      ) {
        return true
      }
      return false
    },
    getModifiers() {
      // get modifiers if there are no sizes
      if (!this.normalizedAddons.sizes) {
        return this.normalizedAddons.addOn.pick_lists
      }
      // get modifiers if there are sizes and no styles
      if (this.normalizedAddons.sizes && !this.normalizedAddons.styles && this.selectedSizeIndex != null) {
        return this.normalizedAddons.addOn[this.selectedSizeIndex].sub.pick_lists
      }
      // get modifiers if there are styles and no sizes
      if (!this.normalizedAddons.sizes && this.normalizedAddons.styles && this.selectedStyleIndex != null) {
        return this.normalizedAddons.addOn[this.selectedStyleIndex].sub.pick_lists
      }
      // get modifiers if there are sizes and styles
      if (
        this.normalizedAddons.sizes &&
        this.normalizedAddons.styles &&
        this.selectedSizeIndex != null &&
        this.selectedStyleIndex != null
      ) {
        return this.normalizedAddons.addOn[this.selectedSizeIndex].styleList[this.selectedStyleIndex].sub.pick_lists
      }
      return []
    },
    getNutritionInfo() {
      // get modifiers if there are no sizes
      if (!this.normalizedAddons.sizes) {
        return this.normalizedAddons.nutrition
      }
      // get modifiers if there are sizes and no styles
      if (this.normalizedAddons.sizes && !this.normalizedAddons.styles && this.selectedSizeIndex != null) {
        return this.normalizedAddons.addOn[this.selectedSizeIndex].nutrition
      }
      // get modifiers if there are styles and no sizes
      if (!this.normalizedAddons.sizes && this.normalizedAddons.styles && this.selectedStyleIndex != null) {
        return this.normalizedAddons.addOn[this.selectedStyleIndex].nutrition
      }
      // get modifiers if there are sizes and styles
      if (
        this.normalizedAddons.sizes &&
        this.normalizedAddons.styles &&
        this.selectedSizeIndex != null &&
        this.selectedStyleIndex != null
      ) {
        return this.normalizedAddons.addOn[this.selectedSizeIndex].styleList[this.selectedStyleIndex].nutrition
      }
      return null
    },
    selectedAllergens() {
      return this.$store.state.selectedAllergens
    },
    selectedItemClasses() {
      return this.$store.state.selectedItemClasses
    },
    allergenIds() {
      if (this.itemData?.allergen_ids && this.selectedAllergens) {
        let allergenIds = this.itemData?.allergen_ids
        return this.getAllergyIconsFilter(allergenIds.filter((id) => this.selectedAllergens.includes(id)))
      } else return []
    },
    itemClassIds() {
      if (this.itemData?.class_ids && this.selectedItemClasses) {
        let itemClassIds = this.itemData?.class_ids
        return this.getClassIconsFilter(itemClassIds.filter((id) => this.selectedItemClasses.includes(id)))
      } else return []
    },
  },
  methods: {
    ...mapMutations([
      'SET_ORDER_DATA',
      'SET_BUTTON_LOADER',
      'SET_TOASTER',
      'SET_LOGGED_IN',
      'SET_DAY_AND_TIME_SELECTED',
      'SET_CUSTOMER_DATA',
      'SET_COOKIES',
      'RESET_COOKIES',
      'SET_ITEM_TOASTER',
    ]),
    getUniqueAllergyIcons() {
      const uniqueAllergenIds = [...new Set(this.itemData.allergen_ids)]
      const uniqueClassIds = [...new Set(this.itemData.class_ids)]
      return this.getAllergyIcons(uniqueAllergenIds, uniqueClassIds)
    },
    expandModifier(pickListId) {
      if (!this.branding?.display_options?.collapsable_modifiers) return
      let modifier = this.expandedModifiers.find((modifier) => modifier.pick_list_id === pickListId)
      if (modifier) {
        this.expandedModifiers = this.expandedModifiers.filter((modifier) => modifier.pick_list_id !== pickListId)
        return
      }
      this.expandedModifiers.push({ pick_list_id: pickListId })
    },
    checkIfModifierVisible(pickListId) {
      if (!this.branding?.display_options?.collapsable_modifiers) return true
      // check if modifier is in expandedModifiers
      let modifier = this.expandedModifiers.find((modifier) => modifier.pick_list_id === pickListId)
      if (modifier) return true
      return false
    },
    checkQtyConditions(event) {
      // if delete key is pressed and quantity is 1, prevent default
      if (event.key === 'Backspace' && this.itemQuantity === 1) {
        event.preventDefault()
      }
      // if quantity is 3 digits and a number key is pressed, prevent default
      if (event.key !== 'Backspace' && `${this.itemQuantity}`.length === 3) {
        event.preventDefault()
      }
      // if quantity is 1 digit and delete key is pressed, prevent default
      if (event.key === 'Backspace' && `${this.itemQuantity}`.length === 1) {
        this.itemQuantity = 1
        event.preventDefault()
      }
      setTimeout(() => {
        if (this.itemData.max_qty && this.itemQuantity > this.itemData.max_qty) {
          this.itemQuantity = this.itemData.max_qty
        }
        if (this.itemData.min_qty && this.itemQuantity < this.itemData.min_qty) {
          this.itemQuantity = this.itemData.min_qty
        }
      }, 1000)
    },
    trackAddToCart() {
      window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'USD',
          value: this.finalPrice / 100,
          items: [
            {
              item_id: this.itemData.item_id,
              item_name: this.itemData.item_name,
              price: this.finalPrice / 100,
              quantity: this.itemQuantity,
              location_id: this.selectedStore.name,
            },
          ],
        },
      })
    },
    findSizeIndex(sizeId) {
      let sizeIndex = this.normalizedAddons.addOn.findIndex((size) => size.sizeid === sizeId)
      return sizeIndex
    },
    findStyleIndex(styleId) {
      let styleIndex = this.normalizedAddons.addOn[this.selectedSizeIndex].styleList.findIndex(
        (style) => style.detail.style_id === styleId
      )
      return styleIndex
    },
    closeModal() {
      this.$emit('closeModal')
    },
    toggleNutritionInfo() {
      this.showNutritionInfo = !this.showNutritionInfo
    },
    getScrolledPosition(event) {
      if (event.target.scrollTop > 400) {
        this.showItemNameBar = true
      } else {
        this.showItemNameBar = false
      }
    },
    selectSize(index) {
      this.selectedSizeIndex = index
      if (this.normalizedAddons.styles) {
        // check if style is present for the selected size
        let stylePresent = this.normalizedAddons.addOn[index].styleList.find(
          (style) => style.detail.style_id === this.selectedStyleId
        )
        if (!stylePresent) {
          this.selectedStyleIndex = null
          this.selectedStyleId = null
          this.sizePrice = this.itemData.pricelist[0].display_price
        } else {
          this.selectedStyleIndex = this.normalizedAddons.addOn[index].styleList.findIndex(
            (style) => style.detail.style_id === this.selectedStyleId
          )
          this.sizePrice = this.normalizedAddons.addOn[index].styleList[this.selectedStyleIndex].priceList.display_price
        }
      }
      this.selectSizeMessage = false
      this.selectedChildItems = []
      this.choicesPrice = 0
      if (!this.normalizedAddons.styles) {
        this.sizePrice = this.normalizedAddons.addOn[index].priceList.display_price
        // when size is selected, scroll to the first modifier
        this.$nextTick(() => {
          let firstModifier = document.querySelector('.modifier')
          if (firstModifier) {
            firstModifier.scrollIntoView({ behavior: 'smooth' })
          }
        })
      }
      if (!this.normalizedAddons.styles) {
        this.getPreSelectedChoices(this.getModifiers)
      }
    },
    selectStyle(index, styleId) {
      this.selectedStyleIndex = index
      this.selectedStyleId = styleId
      this.selectStyleMessage = false
      this.selectedChildItems = []
      this.choicesPrice = 0
      this.sizePrice = this.normalizedAddons.addOn[this.selectedSizeIndex].styleList[index].priceList.display_price
      this.getPreSelectedChoices(this.getModifiers)
      // when size is selected, scroll to the first modifier
      this.$nextTick(() => {
        let firstModifier = document.querySelector('.modifier')
        if (firstModifier) {
          firstModifier.scrollIntoView({ behavior: 'smooth' })
        }
      })
    },
    calculateEditPrice() {
      if (this.normalizedAddons.sizes) {
        let sizeIndex = this.findSizeIndex(this.editItemData.size_id)
        this.selectedSizeIndex = sizeIndex
        if (!this.normalizedAddons.styles) {
          this.sizePrice = this.normalizedAddons.addOn[sizeIndex].priceList.display_price
        } else {
          let styleIndex = this.findStyleIndex(this.editItemData.style_id)
          this.sizePrice = this.normalizedAddons.addOn[sizeIndex].styleList[styleIndex].priceList.display_price
        }
      } else {
        this.sizePrice = this.itemData.pricelist[0].display_price
      }
      this.calculateChoicesPrice()
    },
    checkIfFallbackImage(url) {
      return url.includes('fallback')
    },
    toggleUpsellModal() {
      this.upsellModalIsVisible = !this.upsellModalIsVisible
    },
    goBack(type, itemId) {
      if (type == 'back' && this.nestedModalMode != 'edit') {
        let choice = this.selectedChildItems.find((item) => item.item_id === itemId)
        this.choicesPrice -= choice.price
        this.selectedChildItems = this.selectedChildItems.filter((item) => item.item_id !== itemId)
      }
      this.upsellModalIsVisible = false
      this.itemModalIsVisible = true
    },
    openUpsellModal(modifier, choice, mode) {
      this.modifierId = modifier.pick_list_id
      if (mode == 'edit') {
        this.nestedModalMode = 'edit'
        let childItems = this.selectedChildItems.filter(
          (item) => item.item_id === choice.itemid && item.pick_list_id === this.modifierId
        )
        this.choiceChildItems = childItems[0].child_items || []
        this.parentChoiceQty = childItems[0].quantity
        this.selectedUpsellData = choice
        this.toggleUpsellModal()
        return
      }
      this.nestedModalMode = 'add'
      if (!choice.child_pick_list_data) {
        this.selectChoice(modifier, choice, null, null, 'modal')
        return
      }
      this.selectChoice(modifier, choice, null, null, 'modal')
      // if nested modifier is already selected don't open modal
      if (!this.selectedChildItems.find((item) => item.item_id === choice.itemid)) {
        return
      }
      if (choice.child_pick_list_data.pick_lists) {
        // check if every modifier in choice.child_pick_list_data.pick_lists has display_style == 'hidden'
        // if yes, select choice and then don't open modal
        let allModifiersHidden = true
        allModifiersHidden = choice.child_pick_list_data.pick_lists.every((modifier) => {
          return modifier.display_style === 'hidden'
        })
        if (allModifiersHidden) {
          // go through all modifiers and select preselected choices
          choice.child_pick_list_data.pick_lists.forEach((modifier) => {
            modifier.pick_list_items.forEach((subChoice) => {
              if (subChoice.default_qty != 0) {
                // find their parent choice and add choice to child_items
                let parentChoice = this.selectedChildItems.find((item) => item.item_id === choice.itemid)
                let parentChoiceIndex = this.selectedChildItems.findIndex((item) => item.item_id === choice.itemid)
                if (parentChoice) {
                  let childItem = this.selectChoice(modifier, subChoice, subChoice.default_qty, true, 'modal')
                  if (childItem) {
                    if (this.selectedChildItems[parentChoiceIndex].child_items) {
                      this.selectedChildItems[parentChoiceIndex].child_items.push(childItem)
                    } else {
                      this.selectedChildItems[parentChoiceIndex].child_items = [childItem]
                    }
                  }
                }
              }
            })
          })
          return
        }
      }
      this.selectedUpsellData = choice
      this.toggleUpsellModal()
    },
    changeQty(type) {
      if (type === 'plus') {
        if (this.itemData.max_qty && this.itemQuantity >= this.itemData.max_qty) {
          let toasterData = {
            show: true,
            message:
              'Maximum quantity you can select is ' +
              this.itemData.max_qty +
              ' for ' +
              "'" +
              this.itemData.item_name +
              "'",
          }
          this.SET_TOASTER(toasterData)
          return
        }
        if (this.itemQuantity == 999) {
          let toasterData = {
            show: true,
            message: 'Maximum quantity you can select is 999 for ' + "'" + this.itemData.item_name + "'",
          }
          this.SET_TOASTER(toasterData)
          return
        }
        this.itemQuantity = this.itemQuantity + 1
      } else {
        if (this.itemData.min_qty && this.itemQuantity <= this.itemData.min_qty) {
          let toasterData = {
            show: true,
            message:
              'Minimum quantity you can select is ' +
              this.itemData.min_qty +
              ' for ' +
              "'" +
              this.itemData.item_name +
              "'",
          }
          this.SET_TOASTER(toasterData)
          return
        }
        if (this.itemQuantity > 1) {
          this.itemQuantity = this.itemQuantity - 1
        }
      }
      this.calculateChoicesPrice()
    },
    addToCart() {
      if (this.allergenIds.length > 0 || this.itemClassIds.length > 0) {
        this.toggleItemAllergenModal()
        return
      }
      this.handleAddToCart()
    },
    getSubChoices(childItems, choicePrice, choice) {
      let mainChoice = this.selectedChildItems.find(
        (item) => item.item_id === choice.itemid && item.pick_list_id === this.modifierId
      )
      mainChoice.child_items = childItems
      this.calculateChoicesPrice()
    },
    logOut() {
      customersApi
        .logout()
        .then((response) => {
          if (response.data.data.ok == 'Logged out') {
            this.SET_LOGGED_IN(false)
            this.SET_ORDER_DATA(null)
            localStorage.removeItem('customerId')
            localStorage.removeItem('orderId')
            localStorage.removeItem('selectedTip')
            localStorage.removeItem('dayAndTimeSelected')
            localStorage.removeItem('auth')
            localStorage.removeItem('loggedIn')
            localStorage.removeItem('phoneVerified')
            localStorage.removeItem('newCardData')
            localStorage.removeItem('otherTipAmount')
            this.RESET_COOKIES()
            this.SET_DAY_AND_TIME_SELECTED(false)
            this.SET_CUSTOMER_DATA(null)
            this.$router.push('/')
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateItem(item) {
      let orderId = this.orderData.order.order_id
      let customerId = localStorage.getItem('customerId')
      let payload = {
        customer_id: this.loggedIn ? customerId : localStorage.getItem('guestCustomerId'),
        items: [item],
      }
      ordersApi
        .updateItemOnCart(orderId, payload)
        .then((response) => {
          this.SET_BUTTON_LOADER(false)
          this.SET_ORDER_DATA(response.data.data)
          this.SET_COOKIES(response.data.cookies)
          let toasterData = {
            show: true,
            message: 'Item added to cart',
          }
          this.SET_ITEM_TOASTER(toasterData)
          this.closeModal()
        })
        .catch((error) => {
          this.SET_BUTTON_LOADER(false)
          if (error.response.data.status == 403) {
            let toasterData = {
              show: true,
              message: 'Your session is expired. Please login again.',
            }
            this.SET_TOASTER(toasterData)
            this.logOut()
            return
          }
          let toasterData = {
            show: true,
            message: 'Something went wrong. Please try again later.',
          }
          this.SET_TOASTER(toasterData)
        })
    },
    getFavoriteItems() {
      let customerID = localStorage.getItem('customerId')
      customersApi
        .getFavoriteItems(customerID)
        .then((response) => {
          let favoriteItems = response.data.data
          let favorited = favoriteItems.find((item) => this.itemData.item_id == item.item_id)
          if (favorited) {
            this.favoriteData = favorited
            this.favorited = true
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    favoriteClicked() {
      if (this.favorited) {
        this.removeFromFavorites()
      } else {
        this.addToFavorites()
      }
    },
    addToFavorites() {
      let customerID = localStorage.getItem('customerId')
      let payload = {
        category_id: this.itemData.category_id,
        item_id: this.itemData.item_id,
        quantity: 1,
        favorite_name: this.itemData.item_name,
      }
      customersApi
        .addFavoriteItem(payload, customerID)
        .then((response) => {
          this.favorited = true
          this.favoriteData = response.data.data
          let toasterData = {
            show: true,
            message: this.itemData.item_name + ' added to your favorites',
          }
          this.SET_TOASTER(toasterData)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    removeFromFavorites() {
      let customerID = localStorage.getItem('customerId')
      let payload = {
        favorite_id: this.favoriteData.favorite_id,
      }
      customersApi
        .removeFavoriteItem(payload, customerID)
        .then(() => {
          this.favorited = false
          let toasterData = {
            show: true,
            message: this.itemData.item_name + ' removed from your favorites',
          }
          this.SET_TOASTER(toasterData)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getPreSelectedSize() {
      this.normalizedAddons?.addOn?.forEach((size, index) => {
        if (size.priceList.defaultsize) {
          this.selectSize(index)
        }
      })
    },
    toggleItemAllergenModal() {
      this.ItemAllergenModalIsOpen = !this.ItemAllergenModalIsOpen
    },
    handleAddToCart() {
      this.ItemAllergenModalIsOpen = false
      // addToCart fonksiyonunun kalanını buraya ekleyeceğiz
      if (this.selectedSizeIndex == null && this.normalizedAddons.sizes) {
        this.selectSizeMessage = true
        // scroll to the div with the class sizeWrapper
        let sizeWrapperElement = document.getElementsByClassName('sizeWrapper')[0]
        sizeWrapperElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
        // shake sizeWrapper
        sizeWrapperElement.classList.add('shake')
        setTimeout(() => {
          sizeWrapperElement.classList.remove('shake')
        }, 1500)
        return
      }
      if (this.selectedStyleId == null && this.normalizedAddons.styles) {
        this.selectStyleMessage = true
        // scroll to the div with the class styleWrapper
        let styleWrapperElement = document.getElementsByClassName('styleWrapper')[0]
        styleWrapperElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
        // shake styleWrapper
        styleWrapperElement.classList.add('shake')
        setTimeout(() => {
          styleWrapperElement.classList.remove('shake')
        }, 1500)
        return
      }
      // check if minimum item quantity is met
      if (this.itemData.min_qty && this.itemQuantity < this.itemData.min_qty) {
        let toasterData = {
          show: true,
          message:
            'Minimum quantity you can select is ' +
            this.itemData.min_qty +
            ' for ' +
            "'" +
            this.itemData.item_name +
            "'",
        }
        this.SET_TOASTER(toasterData)
        return
      }
      // check if maximum item quantity is met
      if (this.itemData.max_qty && this.itemQuantity > this.itemData.max_qty) {
        let toasterData = {
          show: true,
          message:
            'Maximum quantity you can select is ' +
            this.itemData.max_qty +
            ' for ' +
            "'" +
            this.itemData.item_name +
            "'",
        }
        this.SET_TOASTER(toasterData)
        return
      }
      // check if required selections are made
      if (this.checkRequiredSelections(this.getModifiers) == false) {
        return
      }
      // check if required selections are made for selected child items
      for (let item in this.selectedChildItems) {
        // find the item in the modifiers
        let modifier = this.getModifiers.find(
          (modifier) => modifier.pick_list_id == this.selectedChildItems[item].pick_list_id
        )
        // find the choice in modifier
        let choice = modifier.pick_list_items.find((choice) => choice.itemid == this.selectedChildItems[item].item_id)
        if (this.checkIfHasRequiredNestedModifiers(modifier, choice)) {
          let toasterData = {
            show: true,
            message: 'Please select required selections for ' + "'" + choice.name + "'",
          }
          this.SET_TOASTER(toasterData)
          return
        }
      }

      // go through all modifiers and multiply quantity with item quantity

      // copy this.selectedChildItems array without reference
      let childItems = JSON.parse(JSON.stringify(this.selectedChildItems))
      childItems.forEach((item) => {
        item.quantity = item.quantity * this.itemQuantity
        if (item.child_items) {
          item.child_items.forEach((childItem) => {
            childItem.quantity = childItem.quantity * this.itemQuantity
            if (childItem.child_items) {
              childItem.child_items.forEach((subChildItem) => {
                subChildItem.quantity = subChildItem.quantity * this.itemQuantity
              })
            }
          })
        }
      })

      if (process.env.VUE_APP_GTM_ID || process.env.VUE_APP_GA4_ID) {
        // GTM track add to cart
        this.trackAddToCart()
      }
      this.SET_BUTTON_LOADER(true)
      let itemPayload = {
        menu_id: parseInt(this.itemData.menu_id),
        quantity: this.itemQuantity,
        item_id: this.itemData.item_id,
        category_id: this.itemData.category_id,
        child_items: childItems,
        comment: this.specialInstructions,
        size_id: this.selectedSizeIndex != null ? this.normalizedAddons.addOn[this.selectedSizeIndex].sizeid : null,
        style_id: this.selectedStyleId,
      }
      if (this.mode == 'edit') {
        itemPayload.order_item_id = this.editItemData.order_item_id
      }
      this.updateItem(itemPayload)
    },
    trapFocus(event) {
      if (event.key === 'Tab') {
        const modal = this.$refs.modal
        if (!modal) {
          return
        }

        const focusableElements = modal.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements.length - 1]

        if (event.shiftKey) {
          // Backward tab
          if (document.activeElement === firstElement) {
            event.preventDefault()
            lastElement.focus()
          }
        } else {
          // Forward tab
          if (document.activeElement === lastElement) {
            event.preventDefault()
            firstElement.focus()
          }
        }
      }
    },
  },
  created() {
    if (this.loggedIn) {
      this.getFavoriteItems()
    }
    if (this.mode == 'edit') {
      this.specialInstructions = this.editItemData.comment
      this.itemQuantity = this.editItemData.quantity
      this.selectedChildItems = this.editItemData.child_items
      this.selectedChildItems.forEach((item) => {
        item.quantity = item.quantity / this.itemQuantity
        if (item.child_items) {
          item.child_items.forEach((childItem) => {
            childItem.quantity = childItem.quantity / this.itemQuantity
            if (childItem.child_items) {
              childItem.child_items.forEach((subChildItem) => {
                subChildItem.quantity = subChildItem.quantity / this.itemQuantity
              })
            }
          })
        }
      })
      if (this.normalizedAddons.sizes) {
        this.selectedSizeIndex = this.findSizeIndex(
          this.editItemData.size_id ? this.editItemData.size_id : this.editItemData.size.item_size_id
        )
      }
      if (this.normalizedAddons.styles) {
        this.selectedStyleIndex = this.findStyleIndex(
          this.editItemData.style_id ? this.editItemData.style_id : this.editItemData.style.item_style_id
        )
        this.selectedStyleId = this.editItemData.style_id
          ? this.editItemData.style_id
          : this.editItemData.style.item_style_id
      }
      this.calculateEditPrice()
    } else {
      this.itemQuantity = this.itemData.min_qty
      if (!this.normalizedAddons.sizes) {
        this.getPreSelectedChoices(this.getModifiers)
      }
      this.sizePrice = this.itemData.pricelist[0].display_price
      if (!this.normalizedAddons.sizes) {
        this.sizePrice = this.itemData.pricelist[0].display_price
      } else {
        this.getPreSelectedSize()
      }
    }
  },
  mounted() {
    this.$refs.modal.focus()

    // Disable scroll on body when modal is open
    document.body.style.overflow = 'hidden'

    // Trap focus within the modal
    document.addEventListener('keydown', this.trapFocus)
    // add event listener for window resize
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  beforeUnmount() {
    document.body.style.overflow = ''

    document.removeEventListener('keydown', this.trapFocus)
    // remove event listener for window resize
    window.removeEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
}
</script>

<style src="../../../assets/css/Modals/ItemModals/WithAddons.css" scoped></style>
